import { ReactNode } from "react";
import { cn } from "@drpcrd/utils/shared";
import { Typography } from "./typography";

const Divider = () => (
  <hr className="border-primary-100! mt-2 mb-1.5 h-px w-full" />
);

type Props = {
  title: string | ReactNode;
  icon?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
  className?: string;
  hideDivider?: boolean;
};

/**
 * CalloutBox component based on Figma design.
 * Features a title with optional icon, a required content area, and an optional footer area.
 * Sections are divided by a separator line.
 */
export const CalloutBox = ({
  title,
  icon,
  children,
  footer,
  className,
  hideDivider = false,
}: Props) => (
  <div
    className={cn(
      "bg-bg-action-secondary-hover border-primary-100! flex flex-col rounded-2xl border p-2",
      className,
    )}
  >
    {/* Header */}
    <div className="flex items-center gap-1">
      {icon && <div className="shrink-0">{icon}</div>}
      {typeof title === "string" ? (
        <Typography weight="semibold" size="sm" className="text-primary-700">
          {title}
        </Typography>
      ) : (
        title
      )}
    </div>

    {/* Divider */}
    {!hideDivider && <Divider />}

    {/* Content (Required Space) */}
    <div>{children}</div>
    {/* Footer (Optional Space) */}
    {footer && (
      <>
        <Divider />
        <div>{footer}</div>
      </>
    )}
  </div>
);
